import { render, staticRenderFns } from "./SimpleSocialMediaArea.vue?vue&type=template&id=41247e32&"
import script from "./SimpleSocialMediaArea.vue?vue&type=script&lang=ts&"
export * from "./SimpleSocialMediaArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports